import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Table } from "reactstrap"
import { useDispatch, useSelector } from "react-redux";
import SubmitFilter from '../../../api/SubmitFilter.js';
import MinimizableContainer from '../../Form/components/MinimizableContainer';
import DocumentModal from '../../Form/components/DocumentModal';
import ResearchKeyDropdown from '../../Form/components/ResearchKeyDropdown';
import { showToastAction } from '../../../redux/toastSlice.js';
import URLS from '../../../utils/URLS.js';

const ResearchResults = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedProject = useSelector(state => state.selectedProject);
    const research = useSelector(state => state.research);
    const allfilters = useSelector(state => state.filters);
    const preferences = useSelector(state => state.preferences);
    const joins = useSelector(state => state.joins);
    const columns = useSelector(state => state.columns);
    const preferencesArray = Object.entries(preferences)

    const [ResultData, setResultData] = useState([]);
    const [filteredPreferences, setFilteredPreferences] = useState([]);

    const keyify = (obj, prefix = '') =>
        Object.keys(obj).reduce((res, el) => {
            if (Array.isArray(obj[el])) {
                return res;
            } else if (typeof obj[el] === 'object' && obj[el] !== null) {
                return [...res, ...keyify(obj[el])];
            }
            return [...res, prefix + el];
        }, []);

    useEffect(() => {
        let temp = []
        if (ResultData.length > 1) {
            keyify(ResultData.at(0))?.map((item, index) => {
                // console.log("seting filtered preferences", temp, item, temp[index-1])
                if (item !== "_id") {
                    if (!JSON.stringify(temp).includes(JSON.stringify([item, true]))) {
                        temp.push([item, true])
                    }
                }
            })
        }
        setFilteredPreferences(temp)
    }, [ResultData])

    useEffect(() => {
        var jsondata = { q1: {}, filters: allfilters };
        if (research.tables.length > 0) {
            jsondata.q1.join_type = research.join_type;
            var conditioncnt = 0;
            var conditionJson = {};
            joins.map((data) => {
                data.conditions.map((data1) => {
                    // var firstcolumnsval = research.tables[data.position[0]]['column_list'][data1[0]];
                    // var secondcolumnsval = research.tables[data.position[1]]['column_list'][data1[1]];
                    var firstcolumnsval = Object.keys(columns[data.position[0]])[data1[0]];
                    var secondcolumnsval = Object.keys(columns[data.position[1]])[data1[1]];
                    conditionJson["condition" + conditioncnt] = [firstcolumnsval, secondcolumnsval];
                    conditioncnt += 1;
                });
            });
            jsondata.q1.join_keys = conditionJson;
            var tableinc = 1;
            research.tables.map((row) => {
                jsondata.q1['table' + tableinc] = row;
                tableinc += 1;
            });
            console.log("check tables ==", jsondata);
            SubmitFilter(selectedProject.name, jsondata)
                .then(res => {
                    console.log("response.---", res.data);
                    let temp = [...res.data.data]
                    temp.map((element, index) => {
                        if (element.hasOwnProperty("R")) {
                            let tempEle = { ...element, ...element.R }
                            temp[index] = tempEle
                        }
                    });
                    setResultData(temp);
                }).catch((err) => {
                    dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
                })
        }
    }, []);

    const SmartText = ({ text, length = 20 }) => {
        const [showLess, setShowLess] = React.useState(true);

        if (text.length < length) {
            return <div>{text}</div>;
        }

        return (
            <div>
                {showLess ? text.slice(0, length) : text}
                {showLess ? <a className="read-or-hide" onMouseOver={() => setShowLess(!showLess)}
                >....</a> : <a className="read-or-hide" onMouseOver={() => setShowLess(true)}
                >...less</a>}
            </div>
        );
    };

    const handleExcelDownload = () => {
        if (ResultData.at(-1) !== undefined) {
            let url = `${URLS.EXCEL_DOWNLOAD_URL}` + ResultData.at(-1);
            window.location.href = url
        }
    }

    return (
        <div className="recent-activities">
            <div className="flex justify-between py-2">
                <h3 className="mb-0 border-0">Résultat</h3>
                <div className="flex gap-2">
                    {/* <Button onClick={() => history.goBack()} color="primary"> */}
                    {/* <i className="ti-back-left mr-2" /> */}
                    {/* See query */}
                    {/* </Button> */}
                    <Button size="sm" onClick={() => handleExcelDownload()}>
                        <i className="ti-download"></i>
                    </Button>
                </div>
            </div>
            <div className="max-h-96 relative new-table-resposive">
                <Table>
                    <thead className="sticky top-0 left-0 bg-white border-0">
                        <tr>
                            {filteredPreferences.map(([pref]) => <th>{pref}</th>)}
                            {/* <th className="text-center">ACTIONS</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {console.log("ResultData ==", ResultData)}
                        {ResultData.length > 1 ? ResultData.at(0).map((val) => {
                            const values = Object.entries(val);
                            const filteredValues = values.filter((val) => preferences[val[0]]);
                            // filteredPreferences.map(([pref]) => {
                            //     const newpref = pref.charAt(0).toUpperCase() + pref.slice(1);
                            // });

                            return <tr>
                                {filteredPreferences.map(([pref]) => <td className="wrapword">{val[pref.charAt(0) + pref.slice(1)] ? <SmartText text={val[pref.charAt(0) + pref.slice(1)]} /> : ''}</td>)}
                                {/* <td className="text-center">
                                    <button onClick={() => handleShow(val)} className="edit-btn" title="edit"><i className="ti-pencil-alt"></i></button>
                                    <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                                </td> */}
                            </tr>
                        }) : <></>}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default ResearchResults
